function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { Fragment, useState, useEffect } from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { addDays, format, getDaysInMonth } from 'date-fns';
import { useConfirmation, Tooltip } from '@signicat/designi/components/overlays';
import { Segment } from '@signicat/designi/components/containers';
import { Message } from '@signicat/designi/components/messages';
import { Flex, Grid } from '@signicat/designi/components/layout';
import { Button } from '@signicat/designi/components/buttons';
import { Heading } from '@signicat/designi/components/text';
import { Icon } from '@signicat/designi/components/icons';
import { List, ListItem } from '@signicat/designi/components/lists';
// import {Skeleton} from '@signicat/designi/components/loaders';
import { media } from '@signicat/designi/helpers/responsive';
import { req, download } from '@signiapp/helpers/api';
import { groupsSelector } from "../store/selectors/signature";
import { DateField } from '@signicat/designi/components/inputs';
import { Feature } from '@signiapp/core/components';
import { t } from "../helpers/i18n";
import SignOrderDelete from "./SignOrderDelete";
import { orders as ordersActions } from "../store/actions";
import SignerDetails from "./SignerDetails";
import getRecipientName from "../helpers/signer";
import formatSignOrderUser from "../helpers/order";
import { Spinner } from '@signicat/designi/components/loaders';
import { ApiError } from '@signiapp/helpers/errors';
import { Notification } from '@signicat/designi/components/messages';
var HiddenFeature = styled(Feature).withConfig({
  displayName: "SignOrderExpanded__HiddenFeature",
  componentId: "sc-o70bu7-0"
})(["display:none;"]);
var Options = styled('div').withConfig({
  displayName: "SignOrderExpanded__Options",
  componentId: "sc-o70bu7-1"
})(["display:flex;flex-direction:column;background:#ffffff;padding:8px;box-shadow:0px 3px 5px rgba(0,0,0,0.2),0px 0px 1px rgba(0,0,0,0.31);border-radius:8px;overflow:hidden;position:absolute;right:20px;top:60%;z-index:2;"]);
var Option = styled('div').withConfig({
  displayName: "SignOrderExpanded__Option",
  componentId: "sc-o70bu7-2"
})(["cursor:pointer;padding:8px 12px;margin-bottom:4px;border-radius:32px;:hover{background-color:#f2f0f6;}&.disabled{pointer-events:none;opacity:0.5;}"]);
var OptionButton = styled(Option).withConfig({
  displayName: "SignOrderExpanded__OptionButton",
  componentId: "sc-o70bu7-3"
})(["color:#ffffff;display:flex;allign-items:center;justify-content:center;background-color:#5A338B;border-radius:32px;:hover{background-color:#2A0062;}"]);
var StyledList = styled(List).withConfig({
  displayName: "SignOrderExpanded__StyledList",
  componentId: "sc-o70bu7-4"
})(["margin-bottom:16px;&:last-child{margin-bottom:0;}"]);
var StyledHeading = styled(Heading).withConfig({
  displayName: "SignOrderExpanded__StyledHeading",
  componentId: "sc-o70bu7-5"
})(["margin-left:11px;"]);
var StyledListItem = styled(ListItem).withConfig({
  displayName: "SignOrderExpanded__StyledListItem",
  componentId: "sc-o70bu7-6"
})(["margin-bottom:4px;padding:4px 11px;color:#272142;position:relative;&:hover{background:#f2f0f6;}"]);
var StyledFileItem = styled(StyledListItem).withConfig({
  displayName: "SignOrderExpanded__StyledFileItem",
  componentId: "sc-o70bu7-7"
})(["&:hover{.download-icon{visibility:visible;}}&:not(:hover){.options{display:none;}}"]);
var StyledFileName = styled('p').withConfig({
  displayName: "SignOrderExpanded__StyledFileName",
  componentId: "sc-o70bu7-8"
})(["font-size:16px;line-height:24px;letter-spacing:-0.025em;margin:0 8px 0 0;flex-grow:1;"]);
var StyledSignerFlex = styled(Flex).withConfig({
  displayName: "SignOrderExpanded__StyledSignerFlex",
  componentId: "sc-o70bu7-9"
})(["margin:4px;&:hover{.download-icon{visibility:visible;}}&:not(:hover){.options{display:none;}}"]);
var DateFieldWrapper = styled('div').withConfig({
  displayName: "SignOrderExpanded__DateFieldWrapper",
  componentId: "sc-o70bu7-10"
})(["width:auto;height:40px !important;"]);
var StyledIcon = styled(Icon).withConfig({
  displayName: "SignOrderExpanded__StyledIcon",
  componentId: "sc-o70bu7-11"
})(["margin-right:4px;svg{height:24px;width:24px;}"]);
var StyledIconButton = styled(Icon).withConfig({
  displayName: "SignOrderExpanded__StyledIconButton",
  componentId: "sc-o70bu7-12"
})(["cursor:pointer;color:#2a0062;border-radius:50%;border:2px solid #2a0062;visibility:hidden;height:24px;width:24px;svg{height:20px;width:20px;}&:hover{background:white;}&.disabled{pointer-events:none;opacity:0.5;}"]);
var SignOrderExpanded = function SignOrderExpanded(props) {
  var _order$documents, _order$attachments2, _order$attachments3, _order$documents2, _signOrder$asyncError, _order$advanced, _order$metaData, _order$metaData2, _order$metaData3, _order$metaData4, _order$metaData5;
  var orderId = props.orderId,
    signOrder = props.signOrder,
    collapse = props.collapse;
  var dispatch = useDispatch();
  var history = useHistory();
  var order = useSelector(function (state) {
    return state.orders.data.find(function (o) {
      return o.id === orderId;
    });
  });
  var orderGroups = useSelector(groupsSelector).filter(function (group) {
    var _order$permissions, _order$permissions$gr;
    return (_order$permissions = order.permissions) === null || _order$permissions === void 0 ? void 0 : (_order$permissions$gr = _order$permissions.groups) === null || _order$permissions$gr === void 0 ? void 0 : _order$permissions$gr.includes(group.group);
  });
  var confirm = useConfirmation();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isConfirmingDelete = _useState2[0],
    setIsConfirmingDelete = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isSharingSignLink = _useState4[0],
    setIsSharingSignLink = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    selectedSigner = _useState6[0],
    setSelectedSigner = _useState6[1];
  var _useState7 = useState(true),
    _useState8 = _slicedToArray(_useState7, 2),
    changeDeadlineEnabled = _useState8[0],
    setChangeDeadlineEnabled = _useState8[1];
  var _useState9 = useState(null),
    _useState10 = _slicedToArray(_useState9, 2),
    optionsOpenFor = _useState10[0],
    setOptionsOpenFor = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isDownloading = _useState12[0],
    setIsDownloading = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    isSending = _useState14[0],
    setIsSending = _useState14[1];
  var _useState15 = useState(),
    _useState16 = _slicedToArray(_useState15, 2),
    error = _useState16[0],
    setError = _useState16[1];
  var _useState17 = useState(),
    _useState18 = _slicedToArray(_useState17, 2),
    notification = _useState18[0],
    setNotification = _useState18[1];
  useEffect(function () {
    dispatch(ordersActions.getById(signOrder.id));
  }, []);
  var orderIsFetched = Boolean(order._lastFetchedById);
  var handleDeleteClick = function handleDeleteClick() {
    setIsConfirmingDelete(true);
  };
  var handleNotificationDismiss = function handleNotificationDismiss() {
    setNotification(null);
  };
  var hasToWaitForSigners = function hasToWaitForSigners(signer) {
    var signers = signOrder.signers,
      isSequentialSigning = signers.some(function (s) {
        return s.order !== 0;
      }),
      hasAnyPastSignerNotSigned = signers.filter(function (s) {
        return s.order < signer.order;
      }).some(function (s) {
        return s.status !== 'signed';
      });
    return signOrder.advanced.stack === 'blue' && isSequentialSigning && hasAnyPastSignerNotSigned;
  };
  var handleShareSignLinkClick = function handleShareSignLinkClick(signer) {
    setIsSharingSignLink(true);
    setSelectedSigner(signer);
  };
  var handleSendAutomaticReminderClick = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(signer) {
      var _err$body;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setIsSending(true);
            _context.prev = 1;
            _context.next = 4;
            return dispatch(ordersActions.sendReminder(signOrder.id, signer.id));
          case 4:
            setNotification(t('signer_details_notification_link_send_success'));
            _context.next = 11;
            break;
          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](1);
            console.error(_context.t0);
            if (_context.t0 instanceof ApiError) {
              setError(((_err$body = _context.t0.body) === null || _err$body === void 0 ? void 0 : _err$body.message) || _context.t0.message);
            } else {
              setError('An unknown error occurred');
            }
          case 11:
            _context.prev = 11;
            setIsSending(false);
            return _context.finish(11);
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 7, 11, 14]]);
    }));
    return function handleSendAutomaticReminderClick(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var openInNewTab = function openInNewTab(url) {
    window.open(url, '_blank', 'noopener,noreferrer');
  };
  var handleCopySignLinkClick = function handleCopySignLinkClick(text) {
    navigator.clipboard.writeText(text).then(function () {
      setNotification(t('signer_details_notification_link_copy_success'));
    }, function (err) {
      setError('Could not copy sign-link!');
      console.error('Could not copy text: ', err);
    });
  };
  var handleCreateMailClick = function handleCreateMailClick(signer) {
    var _signer$metaData, _signer$firstName;
    var body = t('email_body_green_stack_signature');
    var expires = (_signer$metaData = signer.metaData) !== null && _signer$metaData !== void 0 && _signer$metaData.expires ? format(new Date(signer.metaData.expires), 'dd.MM.yyyy HH:mm:ss') : '';
    body = encodeURIComponent(body.replace('{name}', (_signer$firstName = signer.firstName) !== null && _signer$firstName !== void 0 ? _signer$firstName : signer.lastName).replace('{firstName}', signer.firstName).replace('{lastName}', signer.lastName).replace('{title}', signOrder.metaData.title).replace('${signCodeUrl}', signer.signUrl).replace('{sender}', signOrder.contactDetails.name).replace('{expires}', expires).replace('{description}', signOrder.metaData.description));
    body = body.replace(/(?:\r\n|\r|\n)/g, '%0D%0A');
    var subject = t('email_topic_green_stack_signature');
    subject = encodeURIComponent(subject.replace('{title}', signOrder.metaData.title));
    window.location.href = "mailto:".concat(signer.email, "?subject=").concat(subject, "&body=").concat(body, "%0D%0A%0D%0A");
  };
  var handleChangeDeadlineClick = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(date) {
      var dateObject, minExpiresObject, maxExpiresObject, now;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            if (!(!date || !(date instanceof Date) || isNaN(date))) {
              _context2.next = 3;
              break;
            }
            return _context2.abrupt("return");
          case 3:
            dateObject = new Date(date);
            minExpiresObject = addDays(new Date(), 1);
            maxExpiresObject = new Date(order.uiFeatures.maxExpires);
            now = new Date();
            dateObject.setHours(now.getHours(), now.getMinutes(), now.getSeconds());

            // Ensure expiration date does not exceed min expiration date
            if (dateObject < minExpiresObject) {
              dateObject.setTime(minExpiresObject.getTime());
            }

            // Ensure expiration date does not exceed max expiration date
            if (dateObject > maxExpiresObject) {
              dateObject.setTime(maxExpiresObject.getTime());
            }
            _context2.next = 12;
            return dispatch(ordersActions.changeDeadline(signOrder.id, dateObject.toISOString()));
          case 12:
            dispatch(ordersActions.getById(signOrder.id));
            _context2.next = 18;
            break;
          case 15:
            _context2.prev = 15;
            _context2.t0 = _context2["catch"](0);
            console.error(_context2.t0);
          case 18:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[0, 15]]);
    }));
    return function handleChangeDeadlineClick(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  var linkCanBeShared = function linkCanBeShared(signer) {
    var _signOrder$uiFeatures;
    return (signer.signUrl || ((_signOrder$uiFeatures = signOrder.uiFeatures) === null || _signOrder$uiFeatures === void 0 ? void 0 : _signOrder$uiFeatures.showSendManualReminder)) && signer.status !== 'signed' && ['sent', 'partially_signed'].includes(signOrder.status);
  };
  var handleDownload = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(url, filename) {
      var json;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            setIsDownloading(true);
            _context3.next = 4;
            return req(url);
          case 4:
            json = _context3.sent;
            _context3.next = 7;
            return download(json.url, {
              filename: filename
            });
          case 7:
            _context3.next = 13;
            break;
          case 9:
            _context3.prev = 9;
            _context3.t0 = _context3["catch"](0);
            confirm({
              message: t('dialog_download_failed_message'),
              variant: 'info'
            });
            throw _context3.t0;
          case 13:
            _context3.prev = 13;
            setIsDownloading(false);
            return _context3.finish(13);
          case 16:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[0, 9, 13, 16]]);
    }));
    return function handleDownload(_x3, _x4) {
      return _ref3.apply(this, arguments);
    };
  }();
  var handleDownloadAllSignedFiles = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var _order$attachments;
      var url, title;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            url = "/signature/sign-orders/".concat(signOrder.id, "/files/jwt?fileIds=");
            order.documents.forEach(function (doc) {
              if (doc.urls != null && doc.urls.signed != null && doc.signedFileId != null) {
                url += doc.signedFileId + ',';
              }
            });
            if (order.attachments != null) {
              order.attachments.forEach(function (a) {
                if (a.urls != null && a.urls.unsigned != null && a.id != null) {
                  url += a.id + ',';
                }
              });
            }
            url = url.slice(0, -1);
            title = order.documents.length === 1 && !((_order$attachments = order.attachments) !== null && _order$attachments !== void 0 && _order$attachments.length) ? "".concat(order.documents[0].filename) : "".concat(order.metaData.title, ".zip");
            handleDownload(url, title);
          case 6:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function handleDownloadAllSignedFiles() {
      return _ref4.apply(this, arguments);
    };
  }();
  var getSigners = function getSigners() {
    if (order.signers.some(function (s) {
      return s.order !== 0;
    })) {
      return order.signers.sort(function (a, b) {
        return a.order - b.order;
      });
    }
    return order.signers;
  };
  var getSignerStatus = function getSignerStatus(signer) {
    var iconName = 'documentOutlined',
      text = "".concat(t("signer_status_".concat(signer.status)), " ").concat(format(new Date(signer.lastUpdated), 'dd.MM.yyyy HH:mm:ss'));
    var isSignerTurnToSign = order.signers.filter(function (s) {
      return s.order < signer.order;
    }).every(function (s) {
      return s.status === 'signed';
    });
    if (!isSignerTurnToSign) {
      iconName = 'watchLaterOutlined';
      text = t('signer_status_waiting_for_signers');
    } else {
      switch (signer.status) {
        case 'sent':
        case 'email_read':
        case 'link_clicked':
        case 'document_read':
        case 'partially_signed':
        case 'received':
          iconName = 'sendOutlined';
          break;
        case 'signed':
          iconName = 'check';
          break;
        case 'sending_error':
          iconName = 'cancelScheduleSendOutlined';
          break;
        case 'approved':
          iconName = 'thumbUpOutlined';
          break;
        case 'rejected':
          iconName = 'thumbDownOutlined';
          break;
        case 'forwarded':
          iconName = 'forwardOutlined';
          break;
        case 'draft':
        default:
          iconName = 'documentOutlined';
          break;
      }
    }
    return /*#__PURE__*/React.createElement(Tooltip, {
      anchor: /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(StyledIcon, {
        name: iconName
      })),
      arrow: true
    }, ' ', text, ' ');
  };
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Segment, {
    divided: true,
    direction: media.matches.tablet.and('up') ? 'row' : 'column',
    space: "xl",
    margin: "8px 0"
  }, /*#__PURE__*/React.createElement(Flex, {
    flex: "1 0 ".concat(media.matches.tablet.and('up') ? '0' : 'auto'),
    direction: "column"
  }, /*#__PURE__*/React.createElement(Flex, {
    direction: "column",
    marginBottom: "16px"
  }, /*#__PURE__*/React.createElement(StyledHeading, {
    level: 6
  }, t('signorder_heading_recipients_and_status')), order.signers.length === 0 ? /*#__PURE__*/React.createElement(StyledListItem, null, /*#__PURE__*/React.createElement("em", null, "0 ", t('signorder_term_recipients'))) : orderIsFetched ? /*#__PURE__*/React.createElement(StyledList, null, getSigners().map(function (signer) {
    return /*#__PURE__*/React.createElement(StyledListItem, {
      key: signer.id,
      onMouseOver: function onMouseOver() {
        return optionsOpenFor !== signer.id ? setOptionsOpenFor(null) : undefined;
      }
    }, /*#__PURE__*/React.createElement(StyledSignerFlex, {
      direction: "horizontal"
    }, getSignerStatus(signer), /*#__PURE__*/React.createElement(StyledFileName, null, /*#__PURE__*/React.createElement("strong", null, getRecipientName(signer))), /*#__PURE__*/React.createElement(StyledIconButton, {
      size: "xs",
      name: "moreVert",
      onClick: function onClick(e) {
        e.stopPropagation();
        setOptionsOpenFor(optionsOpenFor === signer.id ? null : signer.id);
      },
      className: "download-icon"
    }), optionsOpenFor === signer.id && /*#__PURE__*/React.createElement(Options, {
      className: "options"
    }, linkCanBeShared(signer) && signOrder.advanced.stack === 'blue' && /*#__PURE__*/React.createElement(Option, {
      className: "option ".concat(isSending || hasToWaitForSigners(signer) ? 'disabled' : ''),
      onClick: function onClick() {
        setOptionsOpenFor(null);
        handleSendAutomaticReminderClick(signer);
      }
    }, t('button_text_send_reminder')), linkCanBeShared(signer) && /*#__PURE__*/React.createElement(Option, {
      className: "option",
      onClick: function onClick() {
        setOptionsOpenFor(null);
        handleCopySignLinkClick(signer.signUrl);
      }
    }, t('button_text_signer_link_copy')), linkCanBeShared(signer) && /*#__PURE__*/React.createElement(Option, {
      className: "option",
      onClick: function onClick() {
        setOptionsOpenFor(null);
        handleCreateMailClick(signer);
      }
    }, t('button_text_signer_link_write_email')), /*#__PURE__*/React.createElement(Option, {
      className: "option",
      onClick: function onClick() {
        setOptionsOpenFor(null);
        handleShareSignLinkClick(signer);
      }
    }, t('button_text_contact_info')), linkCanBeShared(signer) && /*#__PURE__*/React.createElement(OptionButton, {
      className: "optionButton",
      onClick: function onClick() {
        setOptionsOpenFor(null);
        openInNewTab(signer.signUrl);
      }
    }, t('button_text_sign_now')))));
  }), error ? /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Message, {
    category: "error"
  }, error)) : null, notification ? /*#__PURE__*/React.createElement(Notification, {
    message: notification,
    onDismiss: function onDismiss() {
      return handleNotificationDismiss();
    }
  }) : null) : order.signers.map(function (signer) {
    return /*#__PURE__*/React.createElement(StyledListItem, {
      key: signer.id
    }, /*#__PURE__*/React.createElement(Flex, {
      direction: "horizontal"
    }, /*#__PURE__*/React.createElement(StyledIcon, {
      name: "signer",
      size: "xs"
    }), /*#__PURE__*/React.createElement(Grid, {
      container: true
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      md: 5
    }))));
  })), /*#__PURE__*/React.createElement(Flex, {
    direction: "column"
  }, /*#__PURE__*/React.createElement(StyledHeading, {
    level: 6
  }, t('signorder_heading_documents')), !order.documents || order.documents.length === 0 ? /*#__PURE__*/React.createElement(StyledListItem, null, /*#__PURE__*/React.createElement("em", null, "0 ", t('signorder_term_documents'))) : orderIsFetched ?
  /*#__PURE__*/
  // Orders which are not entirely fetched were rendered
  // separately because there used to be no data available
  // for non fetched orders. Now that we're getting some
  // data on the list endpoint, should merge fetched and
  // non fetched render
  React.createElement(StyledList, null, (_order$documents = order.documents) === null || _order$documents === void 0 ? void 0 : _order$documents.map(function (doc) {
    return /*#__PURE__*/React.createElement(StyledFileItem, {
      key: doc.id,
      onMouseOver: function onMouseOver() {
        return optionsOpenFor !== doc.id ? setOptionsOpenFor(null) : undefined;
      }
    }, /*#__PURE__*/React.createElement(Flex, {
      direction: "horizontal",
      alignItems: "center"
    }, /*#__PURE__*/React.createElement(StyledIcon, {
      name: "document",
      size: "xs"
    }), /*#__PURE__*/React.createElement(StyledFileName, null, doc.title), /*#__PURE__*/React.createElement(StyledIconButton, {
      size: "xs",
      name: "moreVert",
      onClick: function onClick() {
        return setOptionsOpenFor(optionsOpenFor === doc.id ? null : doc.id);
      },
      className: "download-icon"
    }), optionsOpenFor === doc.id && /*#__PURE__*/React.createElement(Options, {
      className: "options"
    }, /*#__PURE__*/React.createElement(Option, {
      className: "option ".concat(!doc.urls.signed || isDownloading ? 'disabled' : ''),
      onClick: function onClick() {
        setOptionsOpenFor(null);
        doc.urls.signed ? handleDownload(doc.urls.signed, doc.filename) : undefined;
      }
    }, t('download_signed')), /*#__PURE__*/React.createElement(Option, {
      className: "option ".concat(!doc.urls.unsigned || isDownloading ? 'disabled' : ''),
      onClick: function onClick() {
        setOptionsOpenFor(null);
        doc.urls.unsigned ? handleDownload(doc.urls.unsigned, doc.filename) : undefined;
      }
    }, t('download_unsigned')))));
  })) : /*#__PURE__*/React.createElement(StyledList, null, order.documents.map(function (item, index) {
    return /*#__PURE__*/React.createElement(StyledFileItem, {
      key: index
    }, /*#__PURE__*/React.createElement(Flex, {
      direction: "horizontal",
      alignItems: "center"
    }, /*#__PURE__*/React.createElement(StyledIcon, {
      name: "document",
      size: "xs"
    }), /*#__PURE__*/React.createElement(Grid, {
      container: true
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      md: 5
    }, /*#__PURE__*/React.createElement(Flex, {
      flex: "2 0 0",
      margin: "0 8px 0 0"
    })))));
  }))), ((_order$attachments2 = order.attachments) === null || _order$attachments2 === void 0 ? void 0 : _order$attachments2.length) === 0 ? undefined : orderIsFetched && order !== null && order !== void 0 && (_order$attachments3 = order.attachments) !== null && _order$attachments3 !== void 0 && _order$attachments3.length ? /*#__PURE__*/React.createElement(Flex, {
    direction: "column",
    marginTop: "16px"
  }, /*#__PURE__*/React.createElement(StyledHeading, {
    level: 6
  }, t('signorder_heading_attachments')), /*#__PURE__*/React.createElement(StyledList, null, order.attachments.length === 0 ? /*#__PURE__*/React.createElement(StyledFileItem, null, /*#__PURE__*/React.createElement("em", null, "No attachments")) : order.attachments.map(function (attachment) {
    return /*#__PURE__*/React.createElement(StyledFileItem, {
      key: attachment.id
    }, /*#__PURE__*/React.createElement(Flex, {
      direction: "horizontal",
      alignItems: "center"
    }, /*#__PURE__*/React.createElement(StyledIcon, {
      name: "document",
      size: "xs"
    }), /*#__PURE__*/React.createElement(StyledFileName, null, attachment.title), /*#__PURE__*/React.createElement(StyledIconButton, {
      size: "xs",
      name: "download",
      onClick: function onClick() {
        return handleDownload(attachment.urls.unsigned, attachment.filename);
      },
      className: "download-icon ".concat(isDownloading ? 'disabled' : '')
    })));
  }))) : /*#__PURE__*/React.createElement(Flex, {
    direction: "column",
    marginTop: "16px"
  }, /*#__PURE__*/React.createElement(StyledHeading, {
    level: 6
  }, t('signorder_heading_attachments')), /*#__PURE__*/React.createElement(StyledList, null, order.attachments.map(function (item, index) {
    return /*#__PURE__*/React.createElement(StyledFileItem, {
      key: index
    }, /*#__PURE__*/React.createElement(Flex, {
      direction: "horizontal",
      alignItems: "center"
    }, /*#__PURE__*/React.createElement(StyledIcon, {
      name: "attachment",
      size: "xs"
    }), /*#__PURE__*/React.createElement(Grid, {
      container: true
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      md: 5
    }, /*#__PURE__*/React.createElement(Flex, {
      flex: "2 0 0",
      margin: "0 8px 0 0"
    })))));
  }))), (_order$documents2 = order.documents) !== null && _order$documents2 !== void 0 && _order$documents2.length && order.documents.every(function (doc) {
    var _doc$urls;
    return (_doc$urls = doc.urls) === null || _doc$urls === void 0 ? void 0 : _doc$urls.signed;
  }) ? /*#__PURE__*/React.createElement(StyledListItem, {
    key: 'allSignedFiles',
    style: {
      marginTop: '8px',
      background: 'transparent'
    }
  }, /*#__PURE__*/React.createElement(Flex, {
    direction: "horizontal",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Flex, {
    flex: "3 0 0"
  }, /*#__PURE__*/React.createElement(Button, {
    size: "xs",
    icon: "download",
    secondary: true,
    onClick: function onClick() {
      return handleDownloadAllSignedFiles();
    },
    disabled: isDownloading
  }, t('download_all')), isDownloading && /*#__PURE__*/React.createElement(Spinner, {
    color: "#272142",
    size: "24",
    style: {
      transform: 'scale(0.3)'
    }
  })))) : undefined), /*#__PURE__*/React.createElement(Flex, {
    flex: "1 0 ".concat(media.matches.tablet.and('up') ? '0' : 'auto'),
    direction: "column"
  }, ['sending_error'].includes(signOrder.status) ? (_signOrder$asyncError = signOrder.asyncErrors) === null || _signOrder$asyncError === void 0 ? void 0 : _signOrder$asyncError.map(function (error, index) {
    var _signOrder$asyncError2;
    return /*#__PURE__*/React.createElement(Flex, {
      direction: "column",
      alignItems: "stretch",
      marginBottom: "10px",
      key: index
    }, /*#__PURE__*/React.createElement(Heading, {
      level: 6
    }, t(error.title ? error.title : 'unknown_sending_error_title')), /*#__PURE__*/React.createElement(Message, {
      variant: "error"
    }, /*#__PURE__*/React.createElement("p", {
      style: {
        marginBottom: '12px'
      }
    }, (_signOrder$asyncError2 = signOrder.asyncErrors) !== null && _signOrder$asyncError2 !== void 0 && _signOrder$asyncError2.length ? /*#__PURE__*/React.createElement(Fragment, null, " ".concat(t(error.errorMessage), ".")) : /*#__PURE__*/React.createElement(Fragment, null, " ", t('unknown_sending_error')))));
  }) : null, !['deleted'].includes(signOrder.status) ? /*#__PURE__*/React.createElement(Heading, {
    level: 6
  }, t('signorder_heading_actions')) : null, /*#__PURE__*/React.createElement(Flex, null, ['draft', 'sending_error'].includes(signOrder.status) ? /*#__PURE__*/React.createElement(Button, {
    outlined: true,
    icon: "edit",
    size: "md",
    onClick: function onClick() {
      history.push("/signature/create/".concat(signOrder.id));
    }
  }, t('button_text_edit')) : null, ['sent', 'partially_signed', 'expired'].includes(signOrder.status) && ((_order$advanced = order.advanced) === null || _order$advanced === void 0 ? void 0 : _order$advanced.stack) === 'blue' ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(HiddenFeature, {
    featureId: "signature_edit_sent_sign_orders",
    onFeatureToggle: function onFeatureToggle(e) {
      return setChangeDeadlineEnabled(e);
    }
  }), changeDeadlineEnabled && /*#__PURE__*/React.createElement(DateFieldWrapper, null, /*#__PURE__*/React.createElement(DateField, {
    label: t('signing_order_actions_change_deadline'),
    disablePast: true,
    value: order.expires || '',
    onChange: handleChangeDeadlineClick,
    initialFocusedDate: order.expires || order.uiFeatures.maxExpires,
    minDate: addDays(new Date(), 1),
    maxDate: order.uiFeatures.maxExpires
  }))) : null, !['deleted'].includes(signOrder.status) ? /*#__PURE__*/React.createElement(Button, {
    outlined: true,
    icon: "delete",
    size: "md",
    onClick: handleDeleteClick,
    disabled: orderIsFetched === false
  }, t('button_text_delete')) : null), /*#__PURE__*/React.createElement(Flex, {
    direction: "column",
    marginTop: "16px"
  }, /*#__PURE__*/React.createElement(Heading, {
    level: 6
  }, t('signorder_heading_details')), !((_order$metaData = order.metaData) !== null && _order$metaData !== void 0 && _order$metaData.author) ? null : orderIsFetched ? /*#__PURE__*/React.createElement(StyledListItem, {
    key: order.metaData.authorId
  }, /*#__PURE__*/React.createElement(Flex, {
    direction: "horizontal"
  }, /*#__PURE__*/React.createElement(StyledIcon, {
    name: "signer",
    size: "xs"
  }), /*#__PURE__*/React.createElement(Fragment, null, t('signing_order_created_by'), ': ', order.metaData.author))) : /*#__PURE__*/React.createElement(StyledListItem, {
    key: order.metaData.authorId
  }, /*#__PURE__*/React.createElement(Flex, {
    direction: "horizontal"
  }, /*#__PURE__*/React.createElement(StyledIcon, {
    name: "signer",
    size: "xs"
  }), /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 5
  })))), !((_order$metaData2 = order.metaData) !== null && _order$metaData2 !== void 0 && _order$metaData2.lastUserUpdatedBy) && (!((_order$metaData3 = order.metaData) !== null && _order$metaData3 !== void 0 && _order$metaData3.lastUpdatedBy) || ((_order$metaData4 = order.metaData) === null || _order$metaData4 === void 0 ? void 0 : _order$metaData4.lastUpdatedBy) == 'System') ? null : orderIsFetched ? /*#__PURE__*/React.createElement(StyledListItem, {
    key: order.metaData.lastUpdated
  }, /*#__PURE__*/React.createElement(Flex, {
    direction: "horizontal"
  }, /*#__PURE__*/React.createElement(StyledIcon, {
    name: "signer",
    size: "xs"
  }), /*#__PURE__*/React.createElement(Fragment, null, t('signing_order_last_update_by'), ': ', formatSignOrderUser(order.metaData.lastUserUpdatedBy) || formatSignOrderUser(order.metaData.lastUpdatedBy)))) : /*#__PURE__*/React.createElement(StyledListItem, {
    key: order.metaData.lastUpdated
  }, /*#__PURE__*/React.createElement(Flex, {
    direction: "horizontal"
  }, /*#__PURE__*/React.createElement(StyledIcon, {
    name: "signer",
    size: "xs"
  }), /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 5
  })))), !order.permissions ? null : orderIsFetched ? /*#__PURE__*/React.createElement(StyledListItem, {
    key: order.id
  }, /*#__PURE__*/React.createElement(Flex, {
    direction: "horizontal"
  }, /*#__PURE__*/React.createElement(StyledIcon, {
    name: "group",
    size: "xs"
  }), /*#__PURE__*/React.createElement(Fragment, null, t('signing_order_shared_with'), ': ', orderGroups.length === 0 && order.permissions.users.length === 0 ? t('signing_order_shared_with_all') : order.permissions.users.length === 1 && order.permissions.users[0] === ((_order$metaData5 = order.metaData) === null || _order$metaData5 === void 0 ? void 0 : _order$metaData5.authorId) ? t('signing_order_shared_with_private') : orderGroups.map(function (group) {
    return group.displayName;
  }).join(', ')))) : /*#__PURE__*/React.createElement(StyledListItem, {
    key: order.id
  }, /*#__PURE__*/React.createElement(Flex, {
    direction: "horizontal"
  }, /*#__PURE__*/React.createElement(StyledIcon, {
    name: "group",
    size: "xs"
  }), /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 5
  })))), !order.expires ? /*#__PURE__*/React.createElement(StyledListItem, null, /*#__PURE__*/React.createElement("em", null, t('signing_order_no_deadline'))) : orderIsFetched ? /*#__PURE__*/React.createElement(StyledListItem, {
    key: order.expires
  }, /*#__PURE__*/React.createElement(Flex, {
    direction: "horizontal"
  }, /*#__PURE__*/React.createElement(StyledIcon, {
    name: "event",
    size: "xs"
  }), /*#__PURE__*/React.createElement(Fragment, null, t('signing_order_deadline'), ': ', format(new Date(order.expires), 'dd.MM.yyyy')))) : /*#__PURE__*/React.createElement(StyledListItem, {
    key: order.expires
  }, /*#__PURE__*/React.createElement(Flex, {
    direction: "horizontal"
  }, /*#__PURE__*/React.createElement(StyledIcon, {
    name: "event",
    size: "xs"
  }), /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 5
  }))))))), isConfirmingDelete ? /*#__PURE__*/React.createElement(SignOrderDelete, {
    signOrder: order,
    close: function close() {
      return setIsConfirmingDelete(false);
    },
    closeExpanded: function closeExpanded() {
      return collapse();
    }
  }) : null, isSharingSignLink ? /*#__PURE__*/React.createElement(SignerDetails, {
    signer: selectedSigner,
    signOrder: order,
    close: function close() {
      return setIsSharingSignLink(false);
    }
  }) : null);
};
export default SignOrderExpanded;